<template>
  <div>
    <!-- summary section -->
    <section
      v-if="reportData.form.reportType === 'Power Billing'"
      class="pdf-item bg-primary-300 w-full p-4 rounded-lg"
    >
      <SimpleTable
        class="mt-2"
        title="Power Billing Report"
        :headers="header()"
        :items="commonSummaryData()"
        :options="options"
      />
    </section>
    <section
      v-if="reportData.form.reportType === 'Power per Customer Type'"
      class="pdf-item bg-primary-300 w-full p-4 rounded-lg"
    >
      <SimpleTable
        class="mt-2"
        title="Power per Customer Type Report"
        :headers="headerReportPerCustomerType()"
        :items="commonSummaryReportPerCustomerType()"
        :options="options"
      />
    </section>
    <!-- summary section -->
  </div>
</template>
<script>
import SimpleTable from '@/components/dx/SimpleTable'
import reportContentMixin from '@/mixins/ReportContent'

export default {
  mixins: [reportContentMixin],
  props: {
    period: {
      type: String
    },
    exportPdf: {
      type: Boolean
    }
  },
  components: {
    SimpleTable
  },
  data() {
    return {
      grouppedAssets: [],
      assets: [],
      assetsProperties: [],
      grouppedData: {},
      options: {
        allowToAdd: false,
        allowToRefetch: false,
        allowExporting: true,
        autoWidth: false
      }
    }
  },
  methods: {
    header() {
      return [
        {
          type: 'string',
          text: 'Customer Name',
          value: 'Customer Name'
        },
        {
          type: 'string',
          text: 'Account #',
          value: 'Account No'
        },
        {
          type: 'string',
          text: 'Location',
          value: 'Location'
        },
        {
          type: 'string',
          text: 'Contracted Power',
          value: 'Contracted Power'
        },
        {
          type: 'string',
          text: 'Billable Usage',
          value: 'Billable Usage'
        },
        {
          type: 'string',
          text: 'Unit',
          value: 'Unit'
        },
        {
          type: 'string',
          text: 'Status',
          value: 'Status'
        }
      ]
    },
    headerReportPerCustomerType() {
      return [
        {
          type: 'string',
          text: 'Client',
          value: 'Client'
        },
        {
          type: 'string',
          text: 'Total Racks',
          value: 'Total Racks'
        },
        {
          type: 'string',
          text: 'Rack Usage',
          value: 'Rack Usage'
        },
        {
          type: 'string',
          text: 'Total U-Space',
          value: 'Total U-Space'
        },
        {
          type: 'string',
          text: 'U-Space Usage',
          value: 'U-Space Usage'
        },
        {
          type: 'string',
          text: 'Total Nameplate',
          value: 'Total Nameplate'
        },
        {
          type: 'string',
          text: 'Peak Power',
          value: 'Peak Power'
        },
        {
          type: 'string',
          text: 'Average Power',
          value: 'Average Power'
        }
      ]
    },
    commonSummaryData() {
      var bodyData = []

      // get sensor data
      // console.log(this.reportData.report)

      this.reportData.report.ListCoverPowerBilling.map((location, idx) => {
        this.reportData.report.ListCoverPowerBilling[
          idx
        ].resultPowerBillingModels.map((data, index) => {
          let content = {}
          content['Id'] = index
          content['Customer Name'] = data.companyName
          content['Account No'] = data.department
          content['Location'] = data.itaLocation
          content['Contracted Power'] = data.totalContractedPowerkWh
          content['Billable Usage'] = data.billableUsagekWh
          content['Unit'] = 'kWh'
          content['Status'] = data.status

          bodyData.push(content)
        })
        // content['Id'] = index
        // content['Customer Name'] = data.companyName
        // content['Customer ID'] = data.customerId
        // content['Contracted Power'] = data.totalContractedPowerkWh
        // content['Billable Usage'] = data.billableUsagekWh
        // content['Status'] = data.status

        // bodyData.push(content)
      })

      return bodyData
    },
    commonSummaryReportPerCustomerType() {
      var bodyData = []

      // get sensor data

      this.reportData.report.ListCustomer.map((data, index) => {
        let content = {}
        content['Id'] = index
        content['Client'] = data.CustomerType
        content['Total Racks'] = data.DetailSpaceAsset.TotalRack
        content['Rack Usage'] = data.DetailSpaceAsset.RackUsage
        content['Total U-Space'] = data.DetailSpaceAsset.TotalUSpace
        content['U-Space Usage'] = data.DetailSpaceAsset.UsedUspace
        content['Total Nameplate'] = data.DetailPowerITA.TotalNameplate
        content['Peak Power'] = data.DetailSensorDCEPower.PeakStr
        content['Average Power'] = data.DetailSensorDCEPower.AverageStr

        bodyData.push(content)
      })

      return bodyData
    },
    preparePdf() {
      try {
        this.$emit('pdfSource', {
          filename: this.getGeneratedFileName(),
          source: []
        })
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
